
<mat-card>
  <mat-card-content>
  
      <label>Hai annullato il pagamento.</label>
  </mat-card-content>
</mat-card>
